import type { BanWordsRegexPatterns } from './utils';
import { processWithWhiteList } from './utils';

export const filterBanWords = (
  message: string,
  patterns: BanWordsRegexPatterns,
): string => {
  if (!message || typeof message !== 'string') return message;

  return processWithWhiteList(
    message,
    patterns.whiteListRegex,
    processedMessage => {
      let filtered = processedMessage;

      if (patterns.blackListRegex) {
        patterns.blackListRegex.lastIndex = 0;
        filtered = filtered.replace(patterns.blackListRegex, '**');
      }

      if (patterns.innerRegex) {
        patterns.innerRegex.lastIndex = 0;
        filtered = filtered.replace(patterns.innerRegex, '**');
      }

      if (patterns.isolatedRegex) {
        patterns.isolatedRegex.lastIndex = 0;
        // isolatedRegex의 그룹 1은 선행 공백/문자열-시작 boundary — 보존해야 단어만 마스킹된다.
        filtered = filtered.replace(patterns.isolatedRegex, '$1**');
      }

      return filtered;
    },
  );
};
